import { render } from "./AdminActionBox.vue?vue&type=template&id=26ffcd67&scoped=true"
import script from "./AdminActionBox.vue?vue&type=script&lang=js"
export * from "./AdminActionBox.vue?vue&type=script&lang=js"

import "./AdminActionBox.vue?vue&type=style&index=0&id=26ffcd67&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ffcd67"]])

export default __exports__